import axios from 'axios';

const SERVER_PORT = process.env.REACT_APP_SERVER_PORT
const BASE_URL = (SERVER_PORT && SERVER_PORT !== "4242")
  ? `http://localhost:${SERVER_PORT}/api/resirent`
  : "https://api.resirent.org/api/resirent"

export default axios.create({
    baseURL: BASE_URL
})

export const axiosPrivate = axios.create({
    baseURL: BASE_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
});
